const ActionTypes = {
  ADD_USER_ROLE: 'ADD_USER_ROLE',
  UPDATE_USER_ROLE: 'UPDATE_USER_ROLE',
  DELETE_USER_ROLE: 'DELETE_USER_ROLE',
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/actions/UserRoleActionTypes.js